export const GET_UTG_BUNDLE = "GET_UTG_BUNDLE";
export const GET_UTG_BUNDLE_STATUS = "GET_UTG_BUNDLE_STATUS";
export const SET_REQUEST_ID = "SET_REQUEST_ID";
export type GetUtgBundle = {
  type: typeof GET_UTG_BUNDLE;
  payload: any;
  callback?: Function;
};
